import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgServiceNowLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 40 40",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_1663_26320)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M28.6067 9.3778C31.1147 11.113 33.0501 13.5606 34.1643 16.4083C35.2804 19.2541 35.5231 22.3712 34.8631 25.3576C34.2031 28.3439 32.6715 31.0648 30.4625 33.1708C30.2043 33.4226 29.9034 33.6275 29.5734 33.772C29.2434 33.9184 28.8902 34.0042 28.531 34.0238C28.1719 34.0452 27.8109 34.0023 27.4673 33.8949C27.1237 33.7895 26.8015 33.6236 26.5142 33.4031C25.5785 32.7024 24.5381 32.1578 23.4316 31.7909C22.3232 31.422 21.1663 31.2346 19.9996 31.2346C18.833 31.2346 17.6741 31.422 16.5677 31.7909C15.4612 32.1578 14.4188 32.7024 13.4832 33.4031C13.1998 33.6217 12.8814 33.7895 12.5398 33.8969C12.1981 34.0042 11.841 34.0491 11.4838 34.0296C11.1266 34.0121 10.7753 33.9301 10.4472 33.7876C10.1192 33.6451 9.81827 33.446 9.55816 33.1981C7.33359 31.0843 5.79037 28.3478 5.13037 25.3419C4.47038 22.3361 4.72467 19.2014 5.86025 16.3439C6.99583 13.4845 8.95834 11.0349 11.4954 9.31143C14.0325 7.58795 17.0258 6.66863 20.0889 6.67644C23.1327 6.70181 26.0988 7.64456 28.6067 9.3778ZM22.9424 29.1695C23.8781 28.7948 24.7283 28.2326 25.4407 27.5183C26.1531 26.8019 26.7122 25.949 27.0849 25.0082C27.4576 24.0693 27.6362 23.0622 27.609 22.0511C27.609 20.0232 26.8073 18.0791 25.3805 16.6445C23.9538 15.2099 22.0185 14.4038 19.9996 14.4038C17.9808 14.4038 16.0455 15.2099 14.6188 16.6445C13.192 18.0791 12.3903 20.0232 12.3903 22.0511C12.3631 23.0622 12.5417 24.0693 12.9144 25.0082C13.2871 25.949 13.8462 26.8019 14.5586 27.5183C15.271 28.2326 16.1212 28.7948 17.0549 29.1695C17.9905 29.5443 18.9922 29.7238 19.9996 29.6965C21.0052 29.7238 22.0068 29.5443 22.9424 29.1695Z",
				fill: "#62D84E"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1663_26320",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 30.4762,
				height: 27.3844,
				fill: "white",
				transform: "translate(4.76172 6.66669)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgServiceNowLogo);
export { ForwardRef as ReactComponent };
